import React, { useState, useRef, useEffect } from 'react';
import { ChatMessage } from '../types';
// import { chatService } from '../services/api';
import ChatHistory from './ChatHistory';
import ProductsGrid from './ProductsGrid';
// import { useBackgroundPattern } from './BackgroundPatternGenerator';


import './chat.css';
import './decorations.css';


const MainInterface: React.FC = () => {
  const [messages, setMessages] = useState<ChatMessage[]>([]);
  const [currentQuery, setCurrentQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  // const backgroundStyle = useBackgroundPattern(3, 2, 1200, 800);
  // const backgroundStyle = useBackgroundPattern(10, 15, 1200, 800);

  const sendMessage = async (messageContent: string) => {
    const messageId = Date.now().toString();
    const newMessage: ChatMessage = {
      id: messageId,
      query: messageContent,
      timestamp: new Date()
    };
  
    // Add message to state immediately
    setMessages(prev => [...prev, newMessage]);
    setLoading(true);
  
    try {
      const response = await fetch('/api/chatQuery', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newMessage)
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      setMessages(prev =>
        prev.map(msg =>
          msg.id === messageId
            ? { ...msg, response: data }
            : msg
        )
      );
    } catch (err) {
      setError('Failed to get response from server');
      console.error('Error sending query:', err);
      // Remove the message if it failed
      setMessages(prev => prev.filter(msg => msg.id !== messageId));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!currentQuery.trim() || loading) return;

    sendMessage(currentQuery.trim());

    setCurrentQuery('');
    setError(null);
    // const messageId = Date.now().toString();
    // const newMessage: ChatMessage = {
    //   id: messageId,
    //   query: currentQuery.trim(),
    //   timestamp: new Date(),
    // };

    // // Add message to history immediately
    // setMessages(prev => [...prev, newMessage]);
    // setCurrentQuery('');
    // setLoading(true);
    // setError(null);

    // try {
    //   const response = await fetch('/api/chatQuery', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(newMessage)
    //   });

    //   if (!response.ok) {
    //     throw new Error('Network response was not ok');
    //   }

    //   const data = await response.json();
      
    //   setMessages(prev => 
    //     prev.map(msg => 
    //       msg.id === messageId 
    //         ? { ...msg, response: data }
    //         : msg
    //     )
    //   );

    // } catch (err) {
    //   setError('Failed to get response from server');
    //   console.error('Error sending query:', err);
      
    //   // Remove the message if it failed
    //   setMessages(prev => prev.filter(msg => msg.id !== messageId));
    // } finally {
    //   setLoading(false);
    // }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e as any);
    }
  };

  const clearHistory = () => {
    setMessages([]);
    setError(null);
  };

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  }, [currentQuery]);

  const latestResponse = messages.length > 0 ? messages[messages.length - 1]?.response : null;


  return (
    <div className='chat-interface-container' >
      <div
        className="chat-container glass1"
        style={{
          width: (!latestResponse || messages.length === 0 || !latestResponse.products || latestResponse.products.length === 0)? '60vw' : '100vw'
        }}>
        {/* Left Panel - Chat History */}
        <div
          className="chat-panel-container"
          style={{
            width: (!latestResponse || messages.length === 0 || !latestResponse.products || latestResponse.products.length === 0)? '100vw' : '30rem',
            borderRadius: (!latestResponse || messages.length === 0 || !latestResponse.products || latestResponse.products.length === 0)? '15px' : '15px 0px 0px 15px'
          }}>
          <div className='chat-panel-header'
            style={{ borderRadius: (!latestResponse || messages.length === 0 || !latestResponse.products || latestResponse.products.length === 0)? '14px 14px 0 0' : '14px 0 0 0'}}>
            <button
              className='chat-panel-header-button'
              onClick={clearHistory}
            >
              Clear
            </button>
          </div>
          
          <ChatHistory messages={messages} />
          
          {/* Query Input Area */}
          <div className='chat-query-container'>
            <form
              className="chat-query-form"
              onSubmit={handleSubmit}
            >
              <textarea
                style={{
                  // background: loading ? '#6c757d' : '#007bff',
                  cursor: loading ? 'not-allowed' : 'pointer'
                }}
                className='chat-query-textarea'
                ref={textareaRef}
                value={currentQuery}
                onChange={(e) => setCurrentQuery(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Enter your query here... (Press Enter to send, Shift+Enter for new line)"
                disabled={loading}
              />
              
              <button
                className='chat-query-button'
                type="submit"
                disabled={loading || !currentQuery.trim()}
              >
                {loading ? 'Sending...' : 'Send'}
              </button>
            </form>
            
            {error && ( <div className='chat-query-error'> {error} </div> )}
          </div>
        </div>

        {/* Right Panel - Search Results */}
        {(latestResponse && messages.length !== 0 && latestResponse.products && latestResponse.products.length !== 0)
        && (
        <div className='search-results-container'>
          {/* <div className='search-results-header'>
            <h2 style={{ margin: 0, fontSize: '18px', color: '#333' }}>Search Results</h2>
          </div> */}
          
          <div style={{ flex: 1, overflow: 'auto' }}>
            {loading && (
              <div className="search-results-loading">
                <div>Loading results...</div>
              </div>
            )}
            
            {!loading && latestResponse && (
              <ProductsGrid
                response={latestResponse}
                onSendMessage={sendMessage}
                // messages={messages}
              />
            )}
            
            {!loading && !latestResponse && messages.length === 0 && (
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '200px',
                color: '#999',
                textAlign: 'center'
              }}>
                <div>
                  <h3>Welcome to Furnichanter AI-Powered Search Engine</h3>
                  <p>Enter a query in the left panel to get started</p>
                </div>
              </div>
            )}
          </div>
        </div>
        )}
      </div>
    </div>
  );
};

export default MainInterface;